/**
 * CZNA-1469 — the full stop after a meeting's number (`111 $n 2` → `2.`).
 *
 * <p>NK writes the meeting's ordinal with a full stop, always; in the Aleph
 * corpus 19 883 of the 20 183 `111 $n` values carry one, 8 714 of 8 881 in
 * `411` and 202 of 211 in `511` (local corpus, active records, 26. 10. 2026).
 * The heading keeps it (`HeadingComposer`, `keepFullStop` on `$n`), so a
 * number typed without it composes `(2 : 2030 : …)` and stands apart from
 * the rest of the catalogue. The form writes it when the cataloguer leaves
 * the field, so what is saved is what they saw.
 *
 * <p><b>Only a bare number.</b> `1.-2.`, `I.` and text stay as typed — the
 * corpus's 19 other shapes are not the form's to rewrite. And only in the
 * meeting fields, where `$n` is the meeting's number; in `x10` or `x30` it is
 * the number of a part or a section.
 */
/** `${tag}${code}` of every subfield that holds a meeting's ordinal. */
var MEETING_ORDINALS = new Set(['111n', '411n', '511n', '711n']);
var BARE_NUMBER = /^\d+$/;
/** `value` as the subfield `tag $code` stores it: a bare number gets its full stop. */
export var withMeetingOrdinalPeriod = function (tag, code, value) {
    if (!tag || !MEETING_ORDINALS.has("".concat(tag).concat(code)))
        return value;
    var trimmed = value.trim();
    return BARE_NUMBER.test(trimmed) ? "".concat(trimmed, ".") : value;
};
